

 <div class="usermenu-container">

  <button (click)="toggleUserMenu()" *ngIf="user?.fullname || user?.customer?.name">
    <span class="userfullname">{{ user?.fullname }}</span>
    <span class="customer">(<ng-container *ngIf="user?.customer?.name">
        <a style="cursor: pointer;" *ngIf="salesRep">{{ user?.customer?.name }}</a>
        <ng-container *ngIf="!salesRep">{{ user?.customer?.name }}</ng-container>
      </ng-container>)</span>
      <i class="fa fa-user"></i>
      <i class="fa fa-caret-down"></i>
  </button>

  <div class="usermenu" *ngIf="showUserMenu">
      <p>
        <!--{{ 'header.loggedin-as' | translate }}<br/>-->
        <strong>{{ user?.fullname }}</strong><br/>
        {{ user?.email }}
      </p>
      <ul>
        <li *ngIf="salesRep"><a href="javascript:void(0)" (click)="selectCustomer()"><i class="fa fa-id-badge fa-extra-margin"></i>{{ 'usermenu.changecustomer' | translate }}</a></li>
        <li *ngIf="admin"><a href="/admin/"><i class="fa fa-id-badge fa-extra-margin"></i>{{ 'usermenu.adminarea' | translate }}</a></li>
        <li><a routerLink="/logout"><i class="fa fa-sign-out"></i>{{ 'header.logout' | translate }}</a></li>
      </ul>

      <!-- languages -->
      <div *ngIf="languages?.length > 1">
        <h6>{{ 'lang.change-language' | translate }}</h6>
        <app-language-picker
          [languages]="languages"
          (onSelectLanguage)="toggleUserMenu()">
        </app-language-picker>
      </div>

  </div>

</div>
